// Mock data for usage tab
export const mockUsageData = {
    // Top KPIs data
    activeUsersCount: 16320,
    activeUsersPercentage: 20,
    activeUsersPenetration: 32,
    activeUsersPenetrationPercentage: 20,
    totalAdvancesCount: 130560,
    totalAdvancesCountPercentage: 20,
    totalAdvances: 10180000,
    totalAdvancesPercentage: 20,
    
    // Bottom KPIs data
    avgAdvancesPerUser: 8.5,
    avgAdvancesPerUserPercentage: 20,
    avgAdvanceSize: 74.50,
    avgAdvanceSizePercentage: 20,
    avgSessions: 120467,
    avgSessionsPercentage: 20,
    activeUserChurn: 578,
    activeUserChurnPercentage: 20
};

export const usageConfig = {
    title: "Usage KPIs",
    topKPIs: [
        {
            key: 'activeUsersCount',
            title: 'Total Active Users',
            percentageKey: 'activeUsersPercentage'
        },
        {
            key: 'activeUsersPenetration',
            title: 'Active Users Penetration',
            percentageKey: 'activeUsersPenetrationPercentage',
            showProgress: true
        },
        {
            key: 'totalAdvancesCount',
            title: 'Total Advances',
            percentageKey: 'totalAdvancesCountPercentage'
        },
        {
            key: 'totalAdvances',
            title: 'Total Advanced Volume ($)',
            percentageKey: 'totalAdvancesPercentage',
            isCurrency: true
        }
    ],
    charts: [
        {
            title: 'Active Users Over Time',
            type: 'activeUsersOverTime'
        },
        {
            title: 'Advances Over Time',
            type: 'advancesOverTime'
        }
    ],
    bottomKPIs: [
        {
            key: 'avgAdvancesPerUser',
            title: 'Avg. Advances per User',
            percentageKey: 'avgAdvancesPerUserPercentage'
        },
        {
            key: 'avgAdvanceSize',
            title: 'Avg. Advance Size',
            percentageKey: 'avgAdvanceSizePercentage',
            isCurrency: true
        },
        {
            key: 'avgSessions',
            title: 'Avg. Sessions',
            percentageKey: 'avgSessionsPercentage'
        },
        {
            key: 'activeUserChurn',
            title: 'Active User Churn',
            percentageKey: 'activeUserChurnPercentage'
        }
    ]
};
